module.exports = __webpack_public_path__ + "static/media/jessica_simpson_shoes.bd38c3fd.jpg";